import {
  getCustomerRepositoryListQueryKey,
  useCustomerRepositoryPartialUpdate,
} from "@boundless/bl-api-client/customer/services"
import { useQueryClient } from "@tanstack/react-query"
import { getRouteApi } from "@tanstack/react-router"
import { CheckIcon } from "lucide-react"

import {
  useDocuments,
  type CommonDocument,
} from "@/components/documents/context/DocumentsProvider"

export interface UncategorizeDocumentComponentProps {
  doc: CommonDocument
}

export function UncategorizeDocumentComponent({
  doc,
}: UncategorizeDocumentComponentProps) {
  const routeApi = getRouteApi("/_dashboard/documents")
  const { companyUuid } = routeApi.useRouteContext()
  const queryClient = useQueryClient()
  const { allDocuments } = useDocuments()

  const { mutate: updateDoc } = useCustomerRepositoryPartialUpdate({
    mutation: {
      onSuccess: (data) => {
        const updatedList = allDocuments.map((doc) =>
          doc.uuid === data.uuid ? { ...doc, ...data } : doc,
        )
        const queryKey = getCustomerRepositoryListQueryKey(companyUuid)
        queryClient.setQueryData(queryKey, updatedList)
      },
    },
  })

  return (
    <button
      title="Uncategorize document"
      className="bg-primary flex h-4 w-4 cursor-pointer items-center justify-center rounded-full"
      onClick={() =>
        updateDoc({
          companyUuid,
          uuid: doc.uuid,
          data: { isConfirmed: false, type: null },
        })
      }
    >
      <CheckIcon className="h-3 w-3 text-white" />
    </button>
  )
}
